export default "__VITE_ASSET__6e4e8eaa__"